import { isTypeObject as e } from "./is-type-object.js";
//#region src/schema/helpers/is-empty-schema-object.ts
var t = (t) => {
	if (!e(t)) return !1;
	let n = Object.keys(t.properties ?? {}).length === 0, r = t.additionalProperties === void 0 || t.additionalProperties === !1, i = Object.keys(t.patternProperties ?? {}).length === 0;
	return n && r && i;
};
//#endregion
export { t as isEmptySchemaObject };

//# sourceMappingURL=is-empty-schema-object.js.map